import { useState } from "react";
import { UserPlus, QrCode } from "lucide-react";
import { cardFileUrl } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { QrDialog } from "./QrDialog";

export const CardActions = ({ card, theme }) => {
  const { t } = useLang();
  const [qrOpen, setQrOpen] = useState(false);
  const light = theme.bg === "#F7F7F7";

  return (
    <section className="space-y-3" data-testid="card-actions">
      <a href={cardFileUrl(card.slug, "vcard")} download data-testid="save-contact-button"
        style={{ backgroundColor: light ? theme.accent : theme.bg, color: light ? theme.accent_fg : theme.fg }}
        className="btn-press flex min-h-[58px] w-full items-center justify-center gap-3 rounded-2xl px-6 text-base font-bold shadow-lg shadow-black/10 hover:opacity-90">
        <UserPlus className="h-5 w-5" /> {t("save_contact")}
      </a>
      <button type="button" onClick={() => setQrOpen(true)} data-testid="show-qr-button"
        className="btn-press flex min-h-[54px] w-full items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-900 hover:border-slate-900">
        <QrCode className="h-5 w-5" /> {t("show_qr")}
      </button>
      <QrDialog open={qrOpen} onOpenChange={setQrOpen} card={card} />
    </section>
  );
};
